export default function MultiplyCircleIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M5.08333 5.25008L8.58333 8.75008M8.58333 5.25008L5.08333 8.75008M4.5 1.16675H9.16667L12.6667 4.66675V9.33341L9.16667 12.8334H4.5L1 9.33341V4.66675L4.5 1.16675Z"
                stroke="#5A5F6A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
